import React, {useState, useEffect, useRef} from 'react';
import Logo from "../assets/logo v4.png"
import Avatar from '@mui/material/Avatar';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';
import { useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import user from '../assets/user.png';
import edit from '../assets/edit.png';
import { JoinActivityForm } from './JoinActivityForm';
import { CreateActivityForm } from './CreateActivityForm';
import { BatchRegister } from './BatchRegister';
import EditProfileModal from './EditProfileModal';
function stringToColor(string) {
    let hash = 0;
    let i;
  
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
  
    let color = '#';
  
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */
  
    return color;
}
  
function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      fontSize: '0.875rem', // 可以調整這個值來改變字體大小，例如：'0.875rem' (較小) 或 '1.2rem' (較大)
    },
    children: `${name.split('').map((char, index) => index > 0 ? char : '').join('')}`,
    // children: `${name.split('')[1][0]}${name.split('')[2][0]}`,
  };
}

function DropdownItem({ img = '', text = '', onClick = null }) {
  return (
      <li className="dropdownItem" onClick={onClick}>
          <img src={img} alt={text} />
          <span
          style={{
            color: 'black',
            textDecoration: 'none',
            fontSize: '1rem',
            fontWeight: 'bold',
            fontFamily: 'Arial, sans-serif',
            textTransform: 'none',
            textAlign: 'left',
          }}

          >{text}</span>
      </li>
  );
}


export default function IndexPageOfTeacher_Navbar({ callback_setActivities }) {
    const singOut = useSignOut();
    const navigate = useNavigate();

    const name = localStorage.getItem('name');
    const email = localStorage.getItem('email');
    
    let menuRef = useRef();

    const [open, setOpen] = useState(false);
    const [isEditProfileOpen, setIsEditProfileOpen] = useState(false);
    const [isReportOpen, setIsReportOpen] = useState(false);
    const [reportTitle, setReportTitle] = useState('');
    const [reportDescription, setReportDescription] = useState('');

    const handleOpenEditProfile = () => {
        setIsEditProfileOpen(true);
    };

    const handleCloseEditProfile = () => {
        setIsEditProfileOpen(false);
    };

    const handleOpenReport = () => {
        setIsReportOpen(true);
    };

    const handleCloseReport = () => {
        setIsReportOpen(false);
        setReportTitle('');
        setReportDescription('');
    };

    const developerEmail = 'happyjenny12347@gmail.com';

    const buildReportPayload = () => {
      const subject = `[問題回報] ${reportTitle || '無標題'}`;
  
      const bodyLines = [
        `姓名：${name || ''}`,
        `信箱：${email || ''}`,
        `頁面：${window.location.pathname}`,
        `時間：${new Date().toLocaleString('zh-TW')}`,
        '',
        '問題標題：',
        reportTitle || '',
        '',
        '問題說明：',
        reportDescription || '',
      ];
  
      return {
        to: developerEmail,
        subject,
        body: bodyLines.join('\n'),
      };
    };
  
    const openMailto = () => {
      const { to, subject, body } = buildReportPayload();
      const href = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = href;
      handleCloseReport();
    };
  
    const openGmailCompose = () => {
      const { to, subject, body } = buildReportPayload();
      const gmailUrl =
        `https://mail.google.com/mail/?view=cm&fs=1` +
        `&to=${encodeURIComponent(to)}` +
        `&su=${encodeURIComponent(subject)}` +
        `&body=${encodeURIComponent(body)}`;
  
      window.open(gmailUrl, '_blank', 'noopener,noreferrer');
      handleCloseReport();
    };
    useEffect(() => {
        let handler = (e) => {
            if(!menuRef.current.contains(e.target)){
                setOpen(false);
                // console.log(menuRef.current);
            }
        };

        document.addEventListener("mousedown", handler);

        return() => {
            document.removeEventListener("mousedown", handler);
        }
    }, []);
  
    const logout = () => {
      singOut();
      navigate("/");
      localStorage.removeItem('userId');
      localStorage.removeItem('name');
      localStorage.removeItem('email');
      localStorage.removeItem('activityId');
      localStorage.removeItem('groupId');
      localStorage.removeItem('nodeId');
      localStorage.removeItem('nodeDataLength');
      localStorage.removeItem('jwtToken');

    };

    return (
      <>
        <nav ref={menuRef}>
            <div className='nav-logo-container'>
                <img alt='' src={Logo} width={85} height={85} />
            </div>

            <div className='nav-buttons margin-right-2u'>
                <button className='create-activity-button'>
                    <CreateActivityForm callback_setActivities={callback_setActivities} />
                </button>
                <button className='common-button'  onClick={() => navigate("/home")}>回到活動列表</button>
                <BatchRegister callback_setActivities={callback_setActivities} />
                <div className="menu-trigger" onClick={() => { setOpen(!open) }}>
                    <Avatar {...stringAvatar(name)} />
                </div>
            </div>

            <div className={`dropdown-menu ${open? 'active' : 'inactive'}`} >
                <h3>嗨！{name}</h3>
                <ul>
                    <DropdownItem
                            img={edit}
                            text={"編輯個人資料"}
                            onClick={handleOpenEditProfile} 
                    />
                    <DropdownItem
                            img={edit}
                            text={"問題回報"}
                            onClick={handleOpenReport} 
                    />                
                </ul>
                <h3><button className='register-button' onClick={logout}>登出</button></h3>
            </div>
      </nav>
      <EditProfileModal open={isEditProfileOpen} onClose={handleCloseEditProfile} />
      <Dialog open={isReportOpen} onClose={handleCloseReport}>
          <DialogTitle sx={{ color: 'black', textDecoration: 'none' }}>問題回報</DialogTitle>
          <DialogContent>
              <TextField
                  autoFocus
                  margin="dense"
                  id="reportTitle"
                  label="問題標題"
                  type="text"
                  fullWidth
                  variant="standard"
                  value={reportTitle}
                  onChange={(e) => setReportTitle(e.target.value)}
              />
              <TextField
                  margin="dense"
                  id="reportDescription"
                  label="詳細說明"
                  type="text"
                  fullWidth
                  multiline
                  rows={4}
                  variant="standard"
                  value={reportDescription}
                  onChange={(e) => setReportDescription(e.target.value)}
              />
          </DialogContent>
          <DialogActions sx={{ p: 2.5, bgcolor: '#f8f9fa', borderTop: '1px solid #e0e0e0' }}>
              <Button onClick={handleCloseReport}>取消</Button>
              <Button onClick={handleCloseReport}>取消</Button>

                {/* <Button
                onClick={openMailto}
                variant="outlined"
                disabled={!reportTitle || !reportDescription}
                >
                開啟預設信箱
                </Button> */}

                <Button
                onClick={openGmailCompose}
                variant="contained"
                disabled={!reportTitle || !reportDescription}
                >
                用 Gmail 回報
                </Button>
          </DialogActions>
      </Dialog>
      </>
    )
}